export const delivery_man ='Delivery Man'
export const preseller ='Preseller'
export const salesman ='Salesman'
export const dd_supervisor ='DD Supervisor'
export const sdr ='SDR'
export const horeca_ps ='Horeca PS'

export const HORECA_POSITIONS = [delivery_man, horeca_ps, sdr]

export function channelIncludes40(selectedChannel: unknown): boolean {
  if (selectedChannel == null || selectedChannel === "") return false;
  const ids = Array.isArray(selectedChannel) ? selectedChannel : [selectedChannel];
  return ids.some((id) => Number(id) === 40 || id === "40");
}

export function getFinanceReportPositions(selectedChannel: unknown): string[] {
  const base = [salesman, preseller];
  return channelIncludes40(selectedChannel) ? [...base, horeca_ps] : base;
}